import { TagItem } from '@decisiv/ui-components/lib/components/TagInput';

// VINs may be pasted separated by commas, spaces, tabs, or newlines. Split on
// any run of those delimiters so multi-VIN pastes become individual tags.
const DELIMITERS = /[\s,]+/;

export const parseCsvTags = (tags: TagItem[]): TagItem[] =>
  tags.flatMap((tag) => {
    const text = typeof tag === 'string' ? tag : tag.text;
    if (!DELIMITERS.test(text)) return [tag];
    return text
      .split(DELIMITERS)
      .map((v) => v.trim())
      .filter(Boolean);
  });
